import { render } from "./Cod7Page.vue?vue&type=template&id=3c3c0db0&scoped=true"
import script from "./Cod7Page.vue?vue&type=script&lang=js"
export * from "./Cod7Page.vue?vue&type=script&lang=js"

import "./Cod7Page.vue?vue&type=style&index=0&id=3c3c0db0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3c0db0"]])

export default __exports__